"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAnchorLink = void 0;
const styles_1 = require("@mui/material/styles");
const anchor_link_1 = __importDefault(require("../anchor-link"));
exports.StyledAnchorLink = (0, styles_1.styled)(anchor_link_1.default)({
    minHeight: "32px",
    minWidth: "32px"
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3JlbGF0ZWQtcHJvZHVjdC1jYXJkL3N0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxpREFBOEM7QUFDOUMsaUVBQXdDO0FBRTNCLFFBQUEsZ0JBQWdCLEdBQUcsSUFBQSxlQUFNLEVBQUMscUJBQVUsQ0FBQyxDQUFDO0lBQ2pELFNBQVMsRUFBRSxNQUFNO0lBQ2pCLFFBQVEsRUFBRSxNQUFNO0NBQ2pCLENBQUMsQ0FBQyJ9